import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const withAuth = { withCredentials: true, timeout: 10000 };

export async function fetchTutorials() {
  const r = await axios.get(`${API}/tutorials`, withAuth);
  return r.data;
}

export async function fetchTutorial(id) {
  const r = await axios.get(`${API}/tutorials/${id}`, withAuth);
  return r.data;
}

export async function setProgress(id, action) {
  const r = await axios.post(`${API}/tutorials/${id}/progress`, { action }, withAuth);
  return r.data;
}

export async function sendFeedback(id, helpful, note) {
  const r = await axios.post(`${API}/tutorials/${id}/feedback`,
    { helpful, note: note || null }, withAuth);
  return r.data;
}

export async function trackTutorialEvent(id, event, meta) {
  try {
    await axios.post(`${API}/tutorials/${id}/event`,
      { event, meta: meta || null }, withAuth);
  } catch (_e) { /* analytics silent-fail */ }
}
